import { queryOptions } from "@tanstack/react-query";
import { listInvites } from "./invites-api";
import type { ListInvitesParams } from "../invites.types";

export const inviteQueries = {
  all: () => ["invites"] as const,
  list: (params: ListInvitesParams = {}) =>
    queryOptions({
      queryKey: [
        ...inviteQueries.all(),
        "list",
        params.page ?? 0,
        params.limit ?? 10,
        params.search?.trim().toLowerCase() ?? "",
        params.status ?? "all",
      ] as const,
      queryFn: () => listInvites(params),
      staleTime: 30_000,
    }),
};
